<template>
    <div class="publication__edit content-width">

        <div class="publication__edit-wrapper">
            <photo-help-form :server="server"/>
        </div>

        <div class="publication__edit-wrapper">
            <select-location />
        </div>

        <div class="publication__edit-wrapper">
            <publication-slider-gallery />
        </div>

    </div>
</template>

<script>

import StateMixin from "../mixins/StateMixin";

import PhotoHelpForm from "./PhotoHelpForm";
import SelectLocation from "./SelectLocation";
import PublicationSliderGallery from "./PublicationSliderGallery";

export default {
    name: "PhotoHelp",
    props: ['server'],
    mixins: [StateMixin],
    components: { PhotoHelpForm, SelectLocation, PublicationSliderGallery },


    methods:{
        handleSliderHeight(){
            this.$parent.handleSliderHeight()
        },

        isValid(){
            const v = this.$children.map( e => {
                return e.isValid();
            } );

            if( v.includes(false) ){
                this.$emit('parent-update', false );
                return false
            }

            this.$emit('parent-update', true );
            return true

        }
    },



}
</script>

<style scoped>

</style>
